import React from "react";
import { Section, ContentBlock, Paragraph } from "./ui";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { label: "Datenschutz", href: "/datenschutz" },
    { label: "Impressum", href: "/impressum" },
    { label: "AGB", href: "/agb" },
  ];

  return (
    <Section variant="primary" spacing="none" margin={false}>
      <ContentBlock maxWidth="4xl" className="pb-6 mx-auto">
        <div className="order-1 md:order-1">
          <Paragraph
            variant="tiny"
            color="secondary"
            noSpacing
            className="text-left px-0 sm:px-1 whitespace-normal  pr-8"
          >
            WTM Sportwagen ist eine unabhängige Werkstatt und steht in keiner
            Verbindung zu, wird nicht gesponsert, genehmigt, empfohlen oder
            anderweitig unterstützt von der Dr. Ing. h.c. F. Porsche AG.
          </Paragraph>
          <Paragraph
            variant="tiny"
            color="secondary"
            noSpacing
            className="text-left px-0 sm:px-1 whitespace-normal pr-8"
          >
            Alle Rechte an Marken wie Porsche®, dem Porsche Wappen®, den
            Modellbezeichnungen sowie den charakteristischen Formen der
            Fahrzeuge liegen ausschließlich bei der Dr. Ing. h.c. F. Porsche AG.
            Jegliche Nennung erfolgt ausschließlich zu Referenzzwecken.
          </Paragraph>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between space-y-2 md:space-y-0">
          {/* Copyright */}
          <div className="order-1 md:order-1">
            <Paragraph
              variant="tiny"
              color="secondary"
              noSpacing
              className="text-left px-0 sm:px-1 whitespace-normal sm:whitespace-nowrap pr-8"
            >
              Copyright © {currentYear} WTM Sportwagen. Alle Rechte vorbehalten.
            </Paragraph>
          </div>

          {/* Links */}
          <div className="order-1 md:order-2 -ml-2 block w-full">
            <div className="flex flex-wrap items-center">
              {footerLinks.map((link, index) => (
                <React.Fragment key={link.href}>
                  <a
                    href={link.href}
                    className="text-white hover:text-gray-300 transition-colors duration-200 px-1 sm:px-2"
                  >
                    <Paragraph variant="tiny" color="secondary" noSpacing>
                      {link.label}
                    </Paragraph>
                  </a>
                  {index < footerLinks.length - 1 && (
                    <span className="text-white text-opacity-40 text-sm">
                      |
                    </span>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </ContentBlock>
    </Section>
  );
};

export default Footer;
